<ng-container *ngIf="item">
  <textarea id="{{item._elementId}}"
         [disabled]="item._readOnly"
         [(ngModel)]="item.value"
         placeholder="{{item._toolTip}}"
         attr.aria-describedby="help-{{ item._elementId }}"
         attr.aria-required="{{ item._answerRequired }}"
         (blur)="lhcDataService.activeRowOnBlur(item)"
         (focus)="lhcDataService.setActiveRow(item)"
         >
  </textarea>
</ng-container>
